import type { RyftAccountGetResponseType } from "@sellar-io/api-v2/types";
import { useQuery } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import {
  apiV2AssertResponse,
  type ApiV2QueryOptions,
  apiV2Request,
  getDefaultQueryOptionsV2,
} from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useRyftManagementAccount = <TData = RyftAccountGetResponseType,>(
  options?: ApiV2QueryOptions<TData>,
) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useQuery({
    queryKey: [user?.uid, business?.id, ServerStateKeys.RyftManagementAccount],
    queryFn: () =>
      apiV2Request({
        user,
        business,
        method: "get",
        path: "ryft-management/accounts",
      }).then((response) => apiV2AssertResponse<TData>(response).data),
    ...getDefaultQueryOptionsV2({
      context: { scope: "business", user, business },
      options,
    }),
  });
};
